import { CreditCardData } from '../components/StoredCreditCards/index.interfaces';
import { CardType, cardTypeOfCreditCardBrand, CreditCardBrand, Nullable } from '../types';

export const deleteCardArrayAndUpdate = (
  creditCards: CreditCardData[],
  cardToDelete: CreditCardData,
  newSelectedCardPspIdentifier: Nullable<string>,
) => {
  const newCreditCards = creditCards.slice();
  const deletionIndex = newCreditCards.indexOf(cardToDelete);

  if (deletionIndex >= 0) {
    newCreditCards.splice(deletionIndex, 1);
  }

  if (newSelectedCardPspIdentifier) {
    const newSelectedCardIndex = newCreditCards.findIndex(
      (card) => card.pspIdentifier === newSelectedCardPspIdentifier,
    );
    if (newSelectedCardIndex !== -1) {
      newCreditCards[newSelectedCardIndex] = {
        ...newCreditCards[newSelectedCardIndex],
        selected: true,
      };
    }
  }
  return newCreditCards;
};

export const selectCardAndUnselectPrevious = (
  currentCards: CreditCardData[],
  pspIdentifier: string | null,
) => {
  const newCreditCards = currentCards
    .slice()
    .map((c) =>
      c.pspIdentifier === pspIdentifier
        ? { ...c, selected: true }
        : c.selected
        ? { ...c, selected: false }
        : c,
    );
  return newCreditCards;
};

export function normalizeCreditCardBrand(value: unknown): Nullable<CreditCardBrand> {
  if (typeof value === 'string') {
    const maybeCreditCardBrand = value.toLowerCase();
    const cardType = (cardTypeOfCreditCardBrand as Record<string, Nullable<CardType>>)[
      maybeCreditCardBrand
    ];
    return typeof cardType !== 'undefined' ? (maybeCreditCardBrand as CreditCardBrand) : null;
  }
  return null;
}

export function convertCreditCardBrand(value: unknown): Nullable<CardType> {
  const cardType =
    typeof value === 'string'
      ? (cardTypeOfCreditCardBrand as Record<string, Nullable<CardType>>)[value.toLowerCase()]
      : null;
  return cardType === undefined ? null : cardType;
}
